module.exports = __webpack_public_path__ + "static/media/pouring.bc491f34.mp4";